import React from 'react';
import Button from '../../button/Button';
import { BUTTON_TYPE } from '../../button/constants';
import styles from './TopRowStepperButton.styles';

export default function TopRowStepperButtons({steps, activeStepIndex, handlePrevButtonClick = () => {}, handleNextButtonClick = () => {}}){
    return <>
        {
            steps.map((item, idx) => {
                return (
                    <div style={{...styles.buttonsContainer, ...(idx === activeStepIndex ? { display: "flex" } : { display: "none" })}}>
                        {
                            item.prevCb ? 
                                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                                    onClickCb={() => handlePrevButtonClick(item.prevCb)} 
                                    children={item.backButtonText}
                                    style={styles.actionButtonStyle}
                                />
                                : null
                        }
                        {
                            item.submitCb ? <Button type={BUTTON_TYPE.PRIMARY}
                                onClickCb={item.submitButtonDisabled ? item?.submitButtonDisabledInfoCb : () => handleNextButtonClick(item.submitCb)}
                                children={item.submitButtonText}
                                style={styles.actionButtonStyle}
                            />
                            : null
                        }
                    </div>
                )
            })
        }
    </>
}